import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, ref } from "vue";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import GenericComponentSocketValue from "./generic/GenericComponentSocketValue.vue";
import { useElementHoverDelay } from "src/shared/v-components/ui/popover/useElementHoverDelay";
import { LONG_HOVER_DELAY } from "src/shared/app-config";
import { useCampaignFrontendAssets } from "src/shared/store/campaign-built/composables/useCampaignFrontendAssets";
import { useIsEnableableComponentType } from "src/shared/store/component-type/composables/useIsEnableableComponentType";
import EnableableComponentSocketValue from "./enableable/EnableableComponentSocketValue.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentSocketValue',
    props: {
        componentId: {},
        size: { default: "medium" },
        settingName: {}
    },
    emits: ["navigateToViewComponent", "confirmDeleteInstalledComponent"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const relayNavigateToViewComponentEvent = (componentId) => {
            emit("navigateToViewComponent", componentId);
        };
        const relayConfirmDeleteInstalledComponentEvent = () => {
            emit("confirmDeleteInstalledComponent");
        };
        const li = ref(null);
        // Use a computed getter to ensure reactivity for builtComponent
        const { builtComponent } = useBuiltComponent(props.componentId);
        const campaignId = computed(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id; });
        const { campaignFrontendAssets } = useCampaignFrontendAssets(campaignId);
        const campaignFrontendAsset = computed(() => {
            return campaignFrontendAssets.value.find((asset) => asset.getComponentId() === props.componentId);
        });
        const { isEnableableComponentType } = useIsEnableableComponentType(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.type; });
        const isPreviewableComponent = computed(() => {
            return Boolean(campaignFrontendAsset.value);
        });
        const hasCampaignFrontendAsset = computed(() => {
            return !!campaignFrontendAsset.value;
        });
        const hasHoveredLongEnough = useElementHoverDelay(li, LONG_HOVER_DELAY);
        const showPopover = computed(() => {
            return hasCampaignFrontendAsset.value && hasHoveredLongEnough.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(isEnableableComponentType))
                    ? (_openBlock(), _createBlock(EnableableComponentSocketValue, {
                        key: 0,
                        "component-id": _ctx.componentId,
                        size: _ctx.size,
                        "setting-name": _ctx.settingName,
                        onNavigateToViewComponent: relayNavigateToViewComponentEvent,
                        onConfirmDeleteInstalledComponent: relayConfirmDeleteInstalledComponentEvent
                    }, null, 8 /* PROPS */, ["component-id", "size", "setting-name", "onConfirmDeleteInstalledComponent"]))
                    : (_openBlock(), _createBlock(GenericComponentSocketValue, {
                        key: 1,
                        "component-id": _ctx.componentId,
                        size: _ctx.size,
                        "setting-name": _ctx.settingName,
                        onNavigateToViewComponent: relayNavigateToViewComponentEvent,
                        onConfirmDeleteInstalledComponent: relayConfirmDeleteInstalledComponentEvent
                    }, null, 8 /* PROPS */, ["component-id", "size", "setting-name", "onConfirmDeleteInstalledComponent"]))
            ]));
        };
    }
});
